import { ListeTable } from '@mairistem/liste';
import dayjs from 'dayjs';
import _ from 'lodash';
import React from 'react';
import { RegieContext } from '@/contexts';
import type { FactureListePrelevementItemType } from '@/types/facture';
import { formatMonetaire } from '@/utils';

interface PrelevementsListeTableRowProps {
  item: FactureListePrelevementItemType;
  rowProps: Record<string, unknown>;
}

const PrelevementsListeTableRow = (props: PrelevementsListeTableRowProps) => {
  const { item, rowProps } = props;

  const { regies, selectedRegie } = React.useContext(RegieContext);
  // Si 1 seul logiciel facturier, on masque la colonne
  const hideSourceColumn =
    _.size(_.find(regies, { identifiant: selectedRegie })?.logicielsFacturier) <= 1;

  const {
    identifiant,
    numero,
    datePrelevement,
    dateEmission,
    montant,
    cycle,
    source,
    titulaireComptePreleve,
    compteBancairePreleve,
  } = item;

  return (
    <ListeTable.Row key={identifiant} {...rowProps}>
      <ListeTable.Cell
        name="numero"
        // @ts-expect-error
        title={numero}
        style={{ width: 175, height: 60 }}
        verticalAlign="middle"
      >
        <div style={{ display: 'flex' }}>
          <div className="textEllipsis" style={{ paddingRight: 10, flex: 1 }}>
            {numero}
          </div>
        </div>
      </ListeTable.Cell>
      <ListeTable.Cell
        name="datePrelevement"
        textAlign="center"
        style={{ width: 120 }}
        verticalAlign="middle"
      >
        {!_.isNil(datePrelevement) && dayjs(datePrelevement).format('DD/MM/YYYY')}
      </ListeTable.Cell>
      <ListeTable.Cell
        name="montant"
        textAlign="right"
        style={{ width: 130 }}
        verticalAlign="middle"
      >
        {formatMonetaire(montant)}
      </ListeTable.Cell>
      <ListeTable.Cell
        name="cycle"
        // @ts-expect-error
        title={`${cycle}${!_.isNil(dateEmission) && ` - ${dayjs(dateEmission).format('DD/MM/YYYY')}`}`}
        style={{ position: 'relative' }}
        verticalAlign="middle"
      >
        <div style={{ display: 'flex' }}>
          <div className="textEllipsis" style={{ paddingRight: 10, flex: 1 }}>
            {cycle}
          </div>
        </div>
      </ListeTable.Cell>
      {!hideSourceColumn && (
        <ListeTable.Cell name="source" textAlign="center" style={{ width: 90 }}>
          {source}
        </ListeTable.Cell>
      )}
      <ListeTable.Cell
        name="titulaireComptePreleve"
        // @ts-expect-error
        title={titulaireComptePreleve}
        style={{ width: 300 }}
        verticalAlign="middle"
      >
        <div style={{ display: 'flex' }}>
          <div className="textEllipsis" style={{ paddingRight: 10, flex: 1 }}>
            {titulaireComptePreleve}
          </div>
        </div>
      </ListeTable.Cell>
      <ListeTable.Cell
        name="compteBancairePreleve"
        // @ts-expect-error
        title={compteBancairePreleve}
        style={{ width: 350 }}
        verticalAlign="middle"
      >
        <div style={{ display: 'flex' }}>
          <div className="textEllipsis" style={{ paddingRight: 10, flex: 1 }}>
            {compteBancairePreleve}
          </div>
        </div>
      </ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default PrelevementsListeTableRow;
